var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled, { css } from "styled-components";
import Card from "@irati/ui/src/Layout/Card";
var ElevatedCard = styled(Card)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  ", "\n"], ["\n  ",
    "\n"])), function (_a) {
    var theme = _a.theme;
    return css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    margin-top: 20px;\n    box-shadow: ", ";\n    ", "\n  "], ["\n    margin-top: 20px;\n    box-shadow: ", ";\n    ",
        "\n  "])), theme.shadows.mid, theme.mediaQueries.minWidthMedia.desktop(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      margin-top: 0;\n    "], ["\n      margin-top: 0;\n    "]))));
});
export default ElevatedCard;
var templateObject_1, templateObject_2, templateObject_3;
